import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { OutboundApiCallLog, OutboundApiCallLogCreate, OutboundApiCallLogFilter } from '../data/outboundApiCallLog';

export function createOutboundApiCallLogService(client: AxiosInstance) {
  return createCrudService<OutboundApiCallLog, OutboundApiCallLogCreate, OutboundApiCallLogFilter>(
    client,
    '/integration/OutboundApiCallLog',
    'id',
  );
}

export type OutboundApiCallLogService = CrudService<OutboundApiCallLog, OutboundApiCallLogCreate, OutboundApiCallLogFilter>;
